var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.row.isNode)?_c('div',{class:['wiki-table-tree-detailButton']},[_c('router-link',{attrs:{"to":{ name: 'wikiPage', params: {id: _vm.row.getId()} }}},[_vm._v("\n    "+_vm._s(_vm.$t('labels.more'))+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }